<template>
  <svg class="hover-effect"  xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
        d="M6.49844 11.6C6.16844 11.6 5.88594 11.4825 5.65094 11.2475C5.41594 11.0125 5.29844 10.73 5.29844 10.4V3.2C5.29844 2.87 5.41594 2.5875 5.65094 2.3525C5.88594 2.1175 6.16844 2 6.49844 2H11.8984C12.2284 2 12.5109 2.1175 12.7459 2.3525C12.9809 2.5875 13.0984 2.87 13.0984 3.2V10.4C13.0984 10.73 12.9809 11.0125 12.7459 11.2475C12.5109 11.4825 12.2284 11.6 11.8984 11.6H6.49844ZM4.09844 14C3.76844 14 3.48594 13.8825 3.25094 13.6475C3.01594 13.4125 2.89844 13.13 2.89844 12.8V4.4H4.09844V12.8H10.6984V14H4.09844Z"
        fill="#D1D5DB" />
  </svg>
</template>
<style scoped lang="scss">


.hover-effect:hover path {
  fill: var(--gray-500);
}
</style>
